import { api } from '../../_generated/api/assets-api.generated';

export const vulnerabilitiesApi = api.enhanceEndpoints({
  addTagTypes: ['DeviceVulnerability', 'OtCve'],
  endpoints: {
    ReadAllDeviceVulnerabilities: {
      providesTags: [{ type: 'DeviceVulnerability' as const, id: 'LIST' }],
    },
    ReadOtCve: {
      providesTags: (_, __, arg) => [{ type: 'OtCve', id: arg.cveNumber }],
    },
    ReadDeviceVulnerabilitySummary: {
      providesTags: [{ type: 'DeviceVulnerability', id: 'LIST' }],
    },
  },
});

export const {
  useReadAllDeviceVulnerabilitiesQuery,
  useReadOtCveQuery,
  useReadDeviceVulnerabilitySummaryQuery,
} = vulnerabilitiesApi;
